import { render, staticRenderFns } from "./TopRatedStrategies.vue?vue&type=template&id=57607688&scoped=true"
import script from "./TopRatedStrategies.vue?vue&type=script&lang=js"
export * from "./TopRatedStrategies.vue?vue&type=script&lang=js"
import style0 from "./TopRatedStrategies.vue?vue&type=style&index=0&id=57607688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57607688",
  null
  
)

export default component.exports